import React, { useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";

const ViewPaymentFollow = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state?.data;

  return (
    <DashboardLayout>
      <Card sx={{ minHeight: "90vh" }}>
        <CardContent>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Payment Follow Report View
            </MaterialTypography>
          </Stack>
          <div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
              }}
            >
              <Card
                sx={{
                  maxWidth: 700,
                  width: "100%",
                  borderRadius: 3,
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  background: "linear-gradient(135deg, #ffffff, #f8f9fa)",
                }}
              >
                <CardHeader
                  title={
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          Payment Report
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  }
                />
                <CardContent>
                  <Grid container>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Box mt={2}>
                        <MaterialTypography
                          variant="subtitle1"
                          fontWeight="bold"
                        >
                          Customer Details
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Customer Name:</strong> {data?.customerName}
                        </MaterialTypography>
                        <MaterialTypography
                          fontSize="16px"
                          color="textSecondary"
                        >
                          <strong>Customer Code:</strong> {data?.customerCode}
                        </MaterialTypography>
                      </Box>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Box mt={2}>
                        <MaterialTypography
                          variant="subtitle1"
                          fontWeight="bold"
                        >
                          Transaction Details
                        </MaterialTypography>

                        {data?.invoices?.map((v, i) => (
                          <Box key={i}>
                            <MaterialTypography
                              fontSize="16px"
                              color="textSecondary"
                            >
                              <strong>Invoice Number:</strong>{" "}
                              {v?.invoiceNumber}
                            </MaterialTypography>
                            <MaterialTypography
                              fontSize="16px"
                              color="textSecondary"
                            >
                              <strong>Balance:</strong> {v?.balance}
                            </MaterialTypography>
                            <MaterialTypography
                              fontSize="16px"
                              color="textSecondary"
                            >
                              <strong>Partial Paid Amount:</strong>{" "}
                              {v?.partialPaidAmount || "N/A"}
                            </MaterialTypography>
                            <MaterialTypography
                              fontSize="16px"
                              color="textSecondary"
                            >
                              <strong>Remaining Amount:</strong>{" "}
                              {v?.remainingAmount || "N/A"}
                            </MaterialTypography>
                            <MaterialTypography
                              fontSize="16px"
                              color="textSecondary"
                            >
                              <strong>Status:</strong> {v?.status}
                            </MaterialTypography>
                          </Box>
                        ))}
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
                <MaterialBox
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={() => navigate("/payment-follow")}
                  >
                    Back
                  </MaterialButton>
                </MaterialBox>
              </Card>
            </Box>
          </div>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default ViewPaymentFollow;
